import { render } from "./AhAlert.vue?vue&type=template&id=1ff00c97&scoped=true"
import script from "./AhAlert.vue?vue&type=script&lang=js"
export * from "./AhAlert.vue?vue&type=script&lang=js"

import "./AhAlert.vue?vue&type=style&index=0&id=1ff00c97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff00c97"]])

export default __exports__